import angular from 'angular';
import { alerts } from 'app/components/global';
import {
  ssDialogService,
  loaderService,
  vmDataService
} from 'app/services';
import uniqueProductNameValidator from './master-product-unique-name.directive';
import controller from './edit-master-product-dialog.controller';
import template from './edit-master-product-dialog.html';
import masterProductNameMessagesTpl from './messages/master-product.name.messages.html';

export class dialogService {
  getOptions($event, { masterProduct = null }) {
    return {
      controller,
      controllerAs: 'editMasterProductDialogVM',
      locals: {
        masterProduct,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
      bindToController: true,
    };
  }
}

export default angular.module('app.components.admin.vendorManagementAdmin.editMasterProductDialog', [
  alerts,
  ssDialogService,
  loaderService,
  vmDataService,
])
  .service('editMasterProductDialog', dialogService)
  .directive('vmaMasterProductUniqueName', uniqueProductNameValidator)
  .run(($templateCache) => {
    $templateCache.put('master-product.name.messages.html', masterProductNameMessagesTpl);
  })
  .name;

console.log('app.components.admin.vendorManagementAdmin.editMasterProductDialog created');
